<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>  
        <v-layout row wrap>
          <v-flex lg5 sm6 xs12>
            <v-card pa-0> 
              <v-toolbar dark flat dense cad color="primary">
                <v-toolbar-title class="subheading">Form User</v-toolbar-title>
                <v-spacer></v-spacer>
                <div class="form-btn">
                    <v-btn v-if="!isUpdate" @click="save(isUpdate)" v-bind:loading="loading" outline>Create</v-btn>
                    <v-btn v-else @click="save(isUpdate)"  v-bind:loading="loading" outline>Update</v-btn>                                                                                        
                </div>
              </v-toolbar>
              <v-card-text class="">              
                <v-form v-model="valid">                      
                  <v-text-field box
                      label="Username"
                      name="username"                              
                      v-model="formModel.username"
                      v-validate="'required'"
                      data-vv-name="username"  
                      @keyup="setEmail()"
                      :error-messages="errors.collect('username')"  
                      required
                  ></v-text-field>

                  <v-text-field box
                    v-validate="'required|email'"
                    v-model="formModel.email"
                    :error-messages="errors.collect('email')"
                    label="E-mail"
                    data-vv-name="email"
                    required
                  ></v-text-field>  

                  <v-text-field          
                    box                    
                    v-model="formModel.password"
                    :error-messages="errors.collect('password')"
                    label="Password"
                    data-vv-name="password"
                    type="password"
                    required
                  ></v-text-field>  
                   
                  <v-text-field box
                      label="Fullname"
                      name="name"                              
                      v-model="formModel.nama"
                      v-validate="'required'"
                      data-vv-name="name"     
                      :error-messages="errors.collect('name')"  
                      required
                  ></v-text-field>

                  <v-text-field box
                      label="Phone Number"
                      name="phone"                              
                      v-model="formModel.telepon"
                      v-validate="'required'"
                      data-vv-name="phone"     
                      :error-messages="errors.collect('phone')"  
                      required
                  ></v-text-field>


                  <v-text-field
                    label="Jabatan"
                    name="jabatan"                              
                    v-model="formModel.jabatan"
                    v-validate="'required'"
                    data-vv-name="address"     
                    box
                    :error-messages="errors.collect('jabatan')"  
                    required
                  ></v-text-field>             
                                    
                </v-form>  
              </v-card-text>       
            </v-card>
          </v-flex>                  
        </v-layout>          
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Permission from '@/apps/admin/models/User';    
import direct from '@/util/directives';

var model = new Permission();

export default {
    directives : direct, 
    $_veeValidate: {
        validator: 'new'
    },    
    data: () => ({
        pagination : {'sortBy': 'kompetisi_id', 'descending': false, 'rowsPerPage': -1},
        panel:[],
        panelId:[],
        isUpdate:false,
        code: null,
        name:null,
        type: null, 
        swithStatus: false,
        formModel: {
          id      : null,  
          email    : null,          
          username : null,
          password : null,          
          nama : null,
          telepon : null,
          jabatan : null,                              
        },
        tingkats:[],
        detail:[],
        headersDtl:[
          {text:'No', value:'no'},
          {text:'Kompetisi', value:'kompetisi_id'},
          {text:'Tingkat', value:'tingkat'},
          {text:'Area ID', value:'area_id'},
          {text:'', value:'a'},
          {text:'', value:'an'},
        ], 
        statusSwitch :false,
        //countries: Countries,
        balance: [],    
        valid: true,
        loading : false,
        alert : null,
        kompetisis : [],
        kompetisi_id : null,
        idx : 0
    }),        
    mounted () {this.init();}, 
    methods : {
        init(){
            //if(this.$route.query.id){
            this.isUpdate  = true; this.loading= true;
            model.profile().then(res => {                      
                Object.assign(this.formModel, res.data === null ? {}:res.data);
                //this.formModel.userArea.forEach((item,i)=>{this.newDtl(item, i);});
                this.loading=false;
            });                                               
            //}            
            this.$validator.localize('en', this.dictionary);       
        },
        
        setEmail(){
            if(!this.isUpdate){
                this.formModel.email = this.formModel.username + '@realcount.com';
            }
        },                
        
        async save(isUpdate = false) {                
            this.$validator.validateAll();    
            this.formModel.time = this.$moment().valueOf();
            this.formModel.info = null;            
            if( !this.errors.any() ) { this.loading=true;
                var res = isUpdate ? await model.updateProfile(this.formModel): await model.create(this.formModel);                
                if(res.status === 200){  
                    this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                
                    this.$router.go(-1);                    
                } else {
                    var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
                    var text  = res.statusText ? res.statusText: 'Something happened in setting up the request that triggered an Error.';                     
                    if(res.data){ if(res.data.message){ text += ' ' + res.data.message; } else {this.validate(res.data);}}                
                    this.$swal({type: 'error', title: title, text: text});                    
                }
                this.loading=false;
            }             
        },
       
        validate(data){
            data.forEach( (item) => {
                this.$validator.errors.add({field : item.field,msg : item.message});
            });
        },        
                
        checking(data){
            if(data.info){
                if(data.info.action === 'synch' && data.info.data){
                    this.validate(data.info.data);
                }
            }            
        },        
                
        clear () {
            this.formModel = {};
            this.$validator.reset();
        },       
        
        setKompetisi(){
            model.kompetisis().then(res=>{              
              this.kompetisis = res;
            });
        },
        
        notSelectKompetisi(){
            let result = [];
            this.kompetisis.forEach(item=>{
                this.forEach()
                result.push()
            });
        },
        
        nameKompetisi(id){
            var result = ''; this.kompetisis.forEach(item=>{if(id === item.id){result = item.name}});
            return result;
        },
        
        colorKompetisi(id){
            var result = ''; this.kompetisis.forEach(item=>{if(id === item.id){result = item.color}});
            return result;
        },
        
        tingkatKompetisi(id){
            var result = ''; this.kompetisis.forEach(item=>{if(id === item.id){result = item.tingkat}});
            return result;
        },
        
        areaKompetisi(id){
            var result = ''; this.kompetisis.forEach(item=>{if(id === item.id){result = item.area_id;}});
            return result;
        },
        
        customFilter (item, queryText, itemText) {
          const textOne = item.name.toLowerCase()
          //const textTwo = item.abbr.toLowerCase()
          const searchText = queryText.toLowerCase()
          return textOne.indexOf(searchText) > -1; 
        }, 
        
        setTingkats(){
          model.tingkats().then(data =>{
            this.tingkats = data;                               
          });
        },

        nameTingkat(id){
          var result = '';
          this.tingkats.forEach(item=>{if(id === item.id){result = item.name}});
          return result;
        },    
        
        addDtl(newVal){
          this.newDtl({kompetisi_id : newVal, id:null, tingkat:this.tingkatKompetisi(newVal), 
              area:null, areaName:null,
              area_id:this.areaKompetisi(newVal)}, this.idx); 
        },
        
        newDtl(d = null, i = null){
          this.notMagic();               

          this.formModel.userAreas.push({        
            id : d ? d.id : null,            
            kompetisi_id : d ? d.kompetisi_id :null,            
            tingkat : d ? d.tingkat : null,
            area_id : d ? d.area_id :null,
            magic : true,        
          });      
          
          if(d && !this.panelId.includes(d.kompetisi_id)){
            this.panel.push(true);
            this.panelId.push(d.kompetisi_id);
          }
          
          this.detail.push({
            areas:[],
            areaSearch:null,
            areaLoading:false,        
          });      

          if(d && d.area_id){        
            this.setTabular(d.area_id, i);        
          }
          
          this.$watch(['detail', i, 'areaSearch'].join('.'), (search) => {
            let prop = this.formModel.userAreas[i];
            if(search && prop.tingkat && this.detail[i]){
              this.detail[i].areaLoading = true; var parent_id = prop.tingkat === (this.formModel.tingkat+1)? this.formModel.area_id : null;            
              model.areas({'AreaSearch[name]':search,tingkat :prop.tingkat,'AreaSearch[parent_id]':parent_id}).then(res=>{                             
                if(this.detail[i]){
                  this.detail[i].areas = res;              
                  this.detail[i].areaLoading = false;
                }
              });
            }
          }); 
          this.idx++;
        },

        setTabular(area_id, i){      
          let prop = this.formModel.userAreas[i];

          prop.area = null;   
          if(area_id){
            this.detail[i].areaLoading = true; 
            model.areas({tingkat:prop.tingkat,'AreaSearch[id]':prop.area_id}).then(res=>{
              this.detail[i].areas = res;              
              res.forEach((item)=>{
                prop.area = item.name;
                prop.areaName = item.name;                
                prop.area_id = item.id;
              });
              this.detail[i].areaLoading = false;
            });      
          }
        },

        delDtl(props){            
          let index = this.getIndex(this.formModel.userAreas, props.item);                 
          this.formModel.userAreas.splice(index, 1);   
          this.detail.splice(index, 1);   
        }, 

        isMagic(props){     
          let index = this.getIndex(this.formModel.userAreas, props.item);
          props.item.magic = true;
          this.notMagic(index);            
        },

        notMagic(exc = null){
          this.formModel.userAreas.forEach((item, index)=>{
            if(exc !== index){
              this.formModel.userAreas[index].magic = false;
            }
          });               
        },
        
        getIndex(arr, item){
            return arr.findIndex(function(i){return i == item;}); 
        }
    }
}
</script>
